
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { MessageCircle, BookOpen } from 'lucide-react';
import { openWhatsApp } from '@/utils/whatsapp';

const PlantExpertSection = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = "918360249017";
    const message = "Hi! I need expert plant care advice. Can you help me?";
    openWhatsApp(phoneNumber, message);
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
          <div className="text-center md:text-left order-2 md:order-1">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground">
              Lifetime Access to Plant Expert
            </h2>
            <p className="mt-4 text-lg text-muted-foreground max-w-md mx-auto md:mx-0">
              Get personalized care advice, troubleshooting tips, and expert guidance for all your plants. Our certified plant experts are here to help your green friends thrive.
            </p>
            <div className="mt-8 flex flex-col gap-4 justify-center md:justify-start items-stretch">
              <Button size="lg" asChild className="bg-primary text-primary-foreground hover:bg-primary w-full md:w-auto text-sm md:text-base">
                <Link to="/plant-care" className="flex items-center gap-2 justify-center whitespace-nowrap">
                  <BookOpen className="h-4 w-4 md:h-5 md:w-5 flex-shrink-0" />
                  Get Plant Care Tips
                </Link>
              </Button>
              <Button 
                size="lg" 
                onClick={handleWhatsAppClick}
                className="flex items-center gap-2 bg-primary text-primary-foreground hover:bg-primary w-full md:w-auto justify-center text-sm md:text-base whitespace-nowrap"
              >
                <MessageCircle className="h-4 w-4 md:h-5 md:w-5 flex-shrink-0" />
                Chat on WhatsApp
              </Button>
            </div>
          </div>
          <div className="rounded-lg overflow-hidden order-1 md:order-2 h-96 md:h-[28rem]">
            <img 
              loading="lazy"
              alt="Woman holding a small plant, representing our plant expert services" 
              src="/lovable-uploads/5ccba203-0d8c-45ed-b299-4e98133f54bf.png" 
              className="w-full h-full min-w-full object-cover" 
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlantExpertSection;
